
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In Lausanne und Yverdon wurden im April mehrere `}<strong parentName="p">{`Tests mit bis zu 100 Schweizer
Soldaten`}</strong>{` gemacht. Dabei ging es darum, den ETH-Algorithmus für verschiedene
`}<a parentName="p" {...{
        "href": "https://twitter.com/EPFL_en/status/1253762510467084293?s=20"
      }}>{`Lebenssituationen`}</a>{`
zu kalibrieren – zum Beispiel für einen Aufenthalt im Restaurant oder im Zug.
Die Distanz zwischen zwei Benutzern muss so genau wie möglich geschätzt werden
können, unabhängig davon, welches Smartphone-Modell im Einsatz ist oder wo es
sich gerade befindet (etwa in der Hand, in der Hosentasche oder in der
Handtasche).`}</p>
    <p>{`Die Distanzmessung mit Bluetooth Technologie ist
`}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/die-swiss-covid-app-koennte-zu-vielen-fehlalarmen-fuehren-939856251352"
      }}>{`nicht perfekt`}</a>{`,
die Messungen scheinen aber genau genug zu sein, um gute Erfolgschancen zu
haben. Seit Ende Mai wurde die App von mehr als 160’000 Mitarbeitern des Bundes,
der kantonalen Gesundheitsbehörden und der beiden ETH in einer Pilotphase
getestet. Dank weiteren Labor- und Feldtests konnten die Resultate ständig
verbessert werden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;